<template>
  <DatatableReportV3
    id="warranties-todo-table"
    title="Warranties To-Do"
    download-url="/reports/warranties_todo"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { customerClassificationColumns } from "@/lib/customerTypes";

import CONSTANTS from "@/Constants.js";
import EquipmentWarrantyLink from "@/Equipment/EquipmentWarrantyLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        responsive: true,
        order: [[0, "desc"]],
        columns: [
          {
            data: "purchase_date",
            responsivePriority: 4,
            title: "Purchase Date",
            filterName: "sold_on",
            searchable: false
          },
          ...customerClassificationColumns(),
          {
            data: "customer",
            responsivePriority: 1,
            footerClassName: "text-right",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.customers,
            title: "Customer"
          },
          { data: "customer_email", title: "Email", responsivePriority: 17 },
          { data: "customer_phone", title: "Phone", responsivePriority: 6 },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 16
          },
          { data: "address", orderable: false, responsivePriority: 7 },
          { data: "job", responsivePriority: 8 },
          { data: "invoice", responsivePriority: 9 },
          {
            data: "technician",
            responsivePriority: 15,
            filterName: "technician_id",
            searchable: false
          },
          {
            data: "provider_name",
            responsivePriority: 10,
            title: "Provider",
            filterName: "provider",
            searchable: false,
            footerClassName: "text-right",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.providers
          },
          {
            data: "program_name",
            responsivePriority: 2,
            title: "Warranty Program",
            filterName: "program",
            searchable: false,
            footerClassName: "text-right",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.programs
          },
          { data: "sku_number", title: "SKU #", responsivePriority: 11 },
          {
            data: "labor_rate",
            responsivePriority: 13,
            title: "Labor Rate",
            className: "text-right",
            searchable: false
          },
          {
            data: "program_cost",
            responsivePriority: 12,
            title: "Program Cost",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.cost,
            searchable: false
          },
          {
            data: "term_years",
            responsivePriority: 14,
            title: "Term (years)",
            searchable: false
          },
          {
            data: "equipment",
            responsivePriority: 5,
            title: "Equipment (captured)",
            searchable: false,
            orderable: false
          },
          {
            data: "status",
            responsivePriority: 3,
            orderable: false,
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "equipment-warranty-link-vue",
            component: EquipmentWarrantyLink,
            options: {
              store
            }
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
